import { css } from '@emotion/core'
import { useCallback, useEffect, useRef } from 'react'

import { usePictureInPicture } from '../hooks/usePictureInPicture'
import { VideocallStream } from '../model-videochamada'

interface VideochamadaPictureInPictureProps {
  pipStream: VideocallStream
  setPipActive(value: boolean): void
  pipActive: boolean
}

export function VideochamadaPictureInPicture(props: Readonly<VideochamadaPictureInPictureProps>) {
  const { pipStream, setPipActive, pipActive } = props
  const pipVideoRef = useRef<HTMLVideoElement>()
  const stream = pipStream?.stream ?? null

  const { videoRef } = usePictureInPicture({
    active: pipActive && !!pipStream,
    onPipActiveChange: setPipActive,
  })

  const setPipVideoRef = useCallback(
    (element: HTMLVideoElement) => {
      pipVideoRef.current = element
      if (element) {
        element.srcObject = stream
      }
      videoRef(element)
    },
    [stream, videoRef]
  )

  useEffect(() => {
    if (pipVideoRef.current) pipVideoRef.current.srcObject = stream
  }, [stream])

  useEffect(() => {
    if (pipActive && !pipStream) setPipActive(false)
  }, [pipActive, pipStream, setPipActive])

  return <video ref={setPipVideoRef} autoPlay muted playsInline css={styles.pipVideo} disablePictureInPicture={false} />
}

const styles = {
  pipVideo: css`
    position: fixed;
    width: 1px;
    height: 1px;
    opacity: 0;
    pointer-events: none;
  `,
}
